import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NotifyList from './List';
import NotifyCreate from './Create';
import NotifyDetail from './Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
    DelegatedTo: { visible: false, label: '', required: false },
    StartDate: { visible: false, label: '', required: false },
    EndDate: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Details = { visible: true, label: resources.DelegationClause, required: true };
    fields.DelegatedTo = { visible: true, label: languageFile["CONTRACT.WF.DELEGATION.FIELD.DELEGATED_TO"], required: true };
    fields.StartDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.START_DATE"], required: true };
    fields.EndDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.END_DATE"], required: true };

    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;

    return fields;
}

class ActionRouter extends React.Component {
    constructor(props) {
        super(props);

        if (props.mode === 'PM') {
            this.notificationType = '14.2PM';
            this.documentType = 'Document14.2PM';
            this.delegationUserParty = 'PM';
        }
        else if (props.mode === 'SUPERVISOR') {
            this.notificationType = '14.2SUP';
            this.documentType = 'Document14.2SUP';
            this.delegationUserParty = 'Supervisor';
        }
        else if (props.mode === 'SUPPLIER') {
            this.notificationType = 'CONDEL';
            this.documentType = 'DocumentCONDEL';
            this.delegationUserParty = 'Contractor';
        }

        this.notifyingParty = props.workflowItem.notifyingParty;


        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;

        try {
            this.allowCrossPartyDelegationsIsEnabled = props.placeholders.find(ph => ph.replacementKey === 'AllowCrossPartyDelegations')
                .values.find(phItem => phItem.field === 'AllowCrossPartyDelegations').isActive;
        }
        catch (err) {
            console.log('AllowCrossPartyDelegations placeholder not available!');
            this.allowCrossPartyDelegationsIsEnabled = false;
        }

    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;
        return (
            <>
                <Routes caseSensitive>
                    <Route
                        path={workflowItem.config.paths.list}
                        exact
                        element={<NotifyList
                            {...this.props}
                            
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                            allowCrossPartyDelegationsIsEnabled={this.allowCrossPartyDelegationsIsEnabled}
                        />}

                    />
                    <Route
                        path={workflowItem.config.paths.create}
                        exact
                        element={
                            workflowItem.userFilters.mainNotice.createAllowed ? (
                                <NotifyCreate
                                    {...this.props}
                                    allowCrossPartyDelegationsIsEnabled={this.allowCrossPartyDelegationsIsEnabled}
                                    
                                    title={this.notificationName}
                                    delegationUserParty={this.delegationUserParty}
                                    notificationType={this.notificationType}
                                />) : (
                                <Navigate replace to={workflowItem.paths.defaultPath} />
                            )
                        }
                    />
                    <Route
                        path={'/:notificationid/*'}
                        exact
                        element={<NotifyDetail
                            {...this.props}
                            allowCrossPartyDelegationsIsEnabled={this.allowCrossPartyDelegationsIsEnabled}
                            
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                            documentType={this.documentType}
                            delegationUserParty={this.delegationUserParty}
                            notifyUserFilter={workflowItem.notifyUserFilter}
                        />}
                    />
                </Routes>
            </>
        );
    }
}


export default (ActionRouter);